// 9fbef606107a605d69c0edbcd8029e5d

export const GLOBAL_DEPARTMENT_LABELS = 'global.department';

export const globalDepartmentLabels = {
  global: {
    department: {
      lbl_view_all: 'View All',
    },
  },
};
